import {
  getTeamEvents
} from "./chunk-5US3DELL.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/teams/events.ts
import { useInfiniteQuery } from "@tanstack/react-query";
var useGetTeamEvents = (props, options) => {
  return useInfiniteQuery(__spreadProps(__spreadValues({
    queryKey: ["teamEvents", props],
    queryFn: ({ pageParam = 1 }) => getTeamEvents(__spreadProps(__spreadValues({}, props), { page: pageParam })),
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      var _a;
      const hasNext = (_a = lastPage.links) == null ? void 0 : _a.next;
      return hasNext ? lastPageParam + 1 : void 0;
    },
    initialPageParam: 1
  }, options), {
    select: (data) => {
      var _a, _b;
      const pages = data.pages;
      const meta = (_b = (_a = pages == null ? void 0 : pages.slice(-1)) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta;
      return { meta, data: data.pages.flatMap((page) => page.data) };
    }
  }));
};

export {
  useGetTeamEvents
};
//# sourceMappingURL=chunk-HJWHRAKY.mjs.map